var _desc, _defs, _g, _mask;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileImageSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "260px",
    height: "260px",
    viewBox: "0 0 260 260",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Default Person") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 260,
    height: 260
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 260 0 260 215 0 215"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Users/Dash/Generic-Default-Icon-Square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Default-Person"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bitmap"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#7F91A5",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.5,150 C160.047234,150 184,126.271092 184,97 C184,67.7289083 160.047234,44 130.5,44 C100.952766,44 77,67.7289083 77,97 C77,126.271092 100.952766,150 130.5,150 Z M229,245.666667 L229,228.300333 C229,215.757 222.893,204.220667 212.862417,197.825333 C196.889,187.667 169.2105,175 130.5,175 C91.297,175 63.7826667,187.596333 47.9898333,197.754667 C38.0413333,204.15 32,215.651 32,228.123667 L32,281 L229,281",
    id: "Combined-Shape",
    fill: "#DEE2E3",
    mask: "url(#mask-2)"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  }))), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#00234B",
    style: {
      mixBlendMode: "lighten"
    },
    xlinkHref: "#path-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImageSquare);
export default __webpack_public_path__ + "static/media/profileImageSquare.e7dd03367de7c86712b5354201b0f457.svg";
export { ForwardRef as ReactComponent };